<div class="vertical-center align-items-center">
  @if (spinnerTextKey) {
    <div class="horizontal-center">
      <ng-container *ngTemplateOutlet="spinner_only" />
      <div style="height: 2rem" class="ml-2 vertical-center">
        <span [translate]="spinnerTextKey">...</span>
      </div>
    </div>
  } @else {
    <div class="spinner-border" style="color: black" role="status">
      <span class="sr-only">Ladevorgang läuft</span>
    </div>
  }
</div>

<ng-template #spinner_only>
  <div class="spinner-border" style="color: black" role="status">
    <span class="sr-only">Ladevorgang läuft</span>
  </div>
</ng-template>
